import { Typography } from "@mui/material";

import { UserMessage, AssistantMessage } from "./ScoutMessages";
import TabOriginBadge from "./TabOriginBadge";
import {
  resolveViewMode,
  hasOtherTabTurns,
  buildMessageKey,
  getVisibleMessages
} from "./scoutThreadHelpers";

export { getVisibleMessages };

const MESSAGE_COMPONENTS = {
  user: {
    Component: UserMessage,
    buildProps: (msg) => ({ content: msg.content })
  },
  assistant: {
    Component: AssistantMessage,
    buildProps: (msg) => ({ content: msg.content, cards: msg.cards })
  }
};

const ScoutThread = ({ messages, activeTab, viewMode, visibleMessages }) => {
  const effectiveViewMode = resolveViewMode(activeTab, viewMode);
  const showEmptyHelper =
    effectiveViewMode === "filtered" &&
    visibleMessages.length === 0 &&
    hasOtherTabTurns(messages, activeTab);

  return (
    <>
      {visibleMessages.map((msg, idx) => {
        const entry = MESSAGE_COMPONENTS[msg.role];
        if (!entry) {
          return null;
        }
        const { Component, buildProps } = entry;
        const badge =
          effectiveViewMode === "all" ? (
            <TabOriginBadge originTab={msg.activeTab} />
          ) : null;
        return (
          <Component
            key={buildMessageKey(msg, idx)}
            {...buildProps(msg)}
            originTabBadge={badge}
          />
        );
      })}
      {showEmptyHelper && (
        <Typography variant="caption" color="textSecondary">
          No conversation on this tab yet — switch to &quot;Show all conversations&quot;
          to see your full history.
        </Typography>
      )}
    </>
  );
};

export default ScoutThread;
